import React from 'react'
import { Form } from 'react-bootstrap';

// Flattened, deduplicated list of all sport names across age categories/levels
// (source of truth: uk_module_admin_api app/Library/CmTrophySportMatrix.php).
const SPORT_OPTIONS = [
    'Kabbadi', 'Athletics', 'Kho-Kho', 'Murga Jhapat', 'VolleyBall', 'Pitthu',
    'Mallakhamb', 'Tug Of War', 'Goli Block', 'Football', 'Badminton', 'Baseball',
    'Lawn Tennis', 'Table Tennis', 'Taekwondo', 'Basketball', 'Hockey', 'Yogasan',
    'Handball', 'Judo', 'Boxing', 'Karate', 'Swimming', 'Archery', 'Fencing',
    'Wrestling', 'Pencak Silat', 'Powerlifting', 'Weightlifting',
];

const CmTrophySportFilter = ({ className = " ", value, onChange }) => {
    return (
        <>
            <div className="">
                <Form.Select
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    className={`me-2 ${className}`}
                    style={{ width: "100%", padding: "11px 50px 10px 11px" }}
                > <option value="">All Sports</option>
                    {SPORT_OPTIONS.map((sport) => {
                        return (
                            <option key={sport} value={sport}>{sport}</option>
                        )
                    })}
                </Form.Select>
            </div>
        </>
    )
}

export default CmTrophySportFilter
